import { PatientDefaultCommunicationChannelEnum } from "../../services";
import { createSessionStore } from "../session-storage/create-session-store";

type Gender = "MALE" | "FEMALE" | "OTHER" | "UNSPECIFIED";

export type PatientProfile = {
  uuid: string;
  firstName: string;
  lastName: string;
  email: string;
  gender: Gender;
  mobileNumber: string;
  avatar: string | null;
  timezone: string;
  race: string | null;
  middleName: string;
  ethnicity: string | null;
  ssn: string;
  mrn: string;
  emailConsent: boolean;
  messageConsent: boolean;
  callConsent: boolean;
  registrationDate: string;
  birthDate: string;
  emergencyContacts: {
    uuid: string;
    firstName: string;
    lastName: string;
    email: string | null;
    mobile: string;
    relationshipWithPatient: string | null;
  }[];
  pharmacyStores: any[];
  labs: any[];
  radiologies: any[];
  patientInsurances: any[];
  providerId: Record<string, string>;
  locationId: Record<string, string>;
  address: {
    line1: string;
    line2: string;
    city: string;
    state: string;
    country: string;
    zipcode: string;
  };
  maritalStatus: string | null;
  faxNumber: string;
  source: string | null;
  homePhone: string;
  errorMessage: string | null;
  lastAppointment: string | null;
  nextAppointment: string | null;
  active: boolean;
  archive: boolean;
  languages: Record<string, string>;
  lastLogin: string | null;
  customerId: string | null;
  pharmacyLabRadiology: any | null;
  providerNPInumber: number;
  providerContactNo: string;
  providerEmail: string;
  pharmacyLabRadiologyMap: any[];
  category: string | null;
  val: any | null;
  phoneNotAvailable: boolean;
  emailNotAvailable: boolean;
  patientConsentEntities: any | null;
  defaultCommunicationChannel: PatientDefaultCommunicationChannelEnum;
  isReferral: boolean | null;
  emailVerified: boolean;
  patientPortalAccess: boolean | null;
  credentialGenerated: boolean | null;

  patientScriptsureId?: string;
  isScriptSure?: boolean;
  //TODO:[add more fields here]
};

type PatientValue = PatientProfile | undefined;

type Action = [PatientValue, (v: PatientValue) => void];

/**
 * The patient in context lives in sessionStorage so each tab can sit on a
 * different chart — a second tab must not repoint the chart an active tab
 * is looking at.
 */
const patientStore = createSessionStore<PatientValue>("patient", undefined);

const useSelectedPatient = (): Action => {
  const [selectedPatient, setSelectedPatient] = patientStore.useStore();

  return [selectedPatient, setSelectedPatient];
};

export default useSelectedPatient;
